import { createApp } from 'vue'
import TerminalApp from '../components/TerminalApp.vue'
import * as Sentry from "@sentry/browser"

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('terminal-app')
  if (!el) return
  const username = el.dataset.username || null

  // Create Vue app and attach Sentry for Vue-specific error tracking
  const app = createApp(TerminalApp, { username })

  // Manually attach Vue error handler to Sentry
  app.config.errorHandler = (err, instance, info) => {
    Sentry.captureException(err)
    console.error(`Vue error: ${info}`, err)
  }

  app.mount(el)
})
